import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useUI } from "@/context/UIContext";
import { searchService } from "@/services/api";
import {
  CommandDialog, CommandEmpty, CommandGroup, CommandInput,
  CommandItem, CommandList, CommandSeparator,
} from "@/components/ui/command";
import { Car, User, Route, Building2, Hexagon } from "lucide-react";

const GROUPS = [
  { key: "vehicles", heading: "Vehicles", icon: Car },
  { key: "drivers", heading: "Drivers", icon: User },
  { key: "trips", heading: "Trips", icon: Route },
  { key: "facilities", heading: "Facilities", icon: Building2 },
  { key: "geofences", heading: "Geofences", icon: Hexagon },
];

export function GlobalSearch() {
  const { searchOpen, setSearchOpen } = useUI();
  const navigate = useNavigate();
  const [q, setQ] = useState("");
  const [results, setResults] = useState(null);

  useEffect(() => {
    if (!searchOpen) { setQ(""); setResults(null); }
  }, [searchOpen]);

  useEffect(() => {
    let alive = true;
    searchService.search(q).then((r) => { if (alive) setResults(r); });
    return () => { alive = false; };
  }, [q]);

  const go = (path) => { setSearchOpen(false); navigate(path); };
  const r = results || { vehicles: [], drivers: [], trips: [], facilities: [], geofences: [] };
  const total = GROUPS.reduce((sum, g) => sum + (r[g.key]?.length || 0), 0);

  return (
    <CommandDialog open={searchOpen} onOpenChange={setSearchOpen}>
      <CommandInput
        placeholder="Search vehicles, VIN, drivers, facilities…"
        value={q}
        onValueChange={setQ}
        data-testid="global-search-input"
      />
      <CommandList className="max-h-[420px]">
        {q.length >= 2 && total === 0 && <CommandEmpty>No results for "{q}".</CommandEmpty>}
        {q.length < 2 && (
          <div className="px-4 py-8 text-center text-sm text-muted-foreground">
            Keep typing — search needs at least 2 characters.
          </div>
        )}

        {GROUPS.map((g, i) => {
          const items = r[g.key] || [];
          if (items.length === 0) return null;
          const Icon = g.icon;
          return (
            <div key={g.key}>
              {i > 0 && <CommandSeparator />}
              <CommandGroup heading={g.heading}>
                {items.map((item) => (
                  <CommandItem key={item.id} value={`${g.key}-${item.id}-${item.label}`} onSelect={() => go(g.key === "geofences" ? "/geofences" : item.url)}>
                    <Icon className="mr-2 h-4 w-4 text-muted-foreground" />
                    <span className="font-medium">{item.label}</span>
                    {item.sublabel && <span className="ml-2 truncate text-xs text-muted-foreground">{item.sublabel}</span>}
                  </CommandItem>
                ))}
              </CommandGroup>
            </div>
          );
        })}
      </CommandList>
    </CommandDialog>
  );
}
